import { jsxs as C, jsx as d } from "react/jsx-runtime";
import a from "classnames";
import c from "../../utils/colors.js";
import { Svg as f, Path as e } from "./Elements.js";
const p = "M13.772,4.397L14.344,3.825C15.218,2.952 15.218,1.53 14.344,0.657C13.498,-0.189 12.023,-0.189 11.176,0.657L10.599,1.234L13.772,4.397Z", h = "M12.892,5.499L5.926,12.465C5.867,12.524 5.801,12.572 5.728,12.609L1.106,14.919C0.812,15.067 0.456,15.008 0.224,14.776C-0.008,14.544 -0.067,14.188 0.081,13.894L2.391,9.273C2.428,9.199 2.476,9.133 2.535,9.074L9.501,2.108L12.892,5.499Z", g = ({
  className: o = "",
  clipRule: t = "evenodd",
  fill: n = c.blueGrey,
  fillRule: m = "evenodd",
  strokeLinejoin: s = "round",
  strokeMiterlimit: L = "2",
  viewBox: i = "0 0 15 15",
  focusable: r
}) => /* @__PURE__ */ C(
  f,
  {
    className: a({ [o]: !!o }),
    clipRule: t,
    fill: n,
    fillRule: m,
    strokeLinejoin: s,
    strokeMiterlimit: L,
    viewBox: i,
    focusable: !!r,
    "aria-hidden": !r,
    children: [
      /* @__PURE__ */ d(e, { d: p }),
      /* @__PURE__ */ d(e, { d: h })
    ]
  }
);
export {
  g as default
};
